import React from 'react';

import { AGE_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';

export const AgeCheckboxesPopover = ({ onCountChange, ...props }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const selectedAge = useWatch({ name: 'age' });
  const filterCount = selectedAge ? 1 : 0;
  useFilterCount('age', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="ageFilter"
      triggerValue={t('age')}
      {...props}
    >
      <CheckboxCustomFilter
        control={control}
        name="age"
        options={AGE_OPTIONS.raw}
      />
    </CustomFilterPopover>
  );
};
